import React, { memo, useEffect, useMemo } from "react";
import GradeSelectorBase from "./GradeSelectorBase";
import { ComponentRegistryProvider } from "./componentRegistry";
import CompareButton from "./selector/item/CompareButton";
import { updateTrackingLayerVersioning } from "../../utils/tracking";
import { aemGradeSelectorLexusModalMap } from "./modals/modals";
import { useModalMap } from "../../../../../common-deprecated/containers/ModalProvider";

const GradeSelector = (): JSX.Element => {
    const componentRegistry = useMemo(
        () => ({
            CompareButton,
            BackToModel: memo(() => null),
        }),
        [],
    );

    useEffect(() => {
        updateTrackingLayerVersioning();
    }, []);

    useModalMap(aemGradeSelectorLexusModalMap);

    return (
        <ComponentRegistryProvider registry={componentRegistry}>
            <GradeSelectorBase />
        </ComponentRegistryProvider>
    );
};

export default GradeSelector;
